import React from 'react'

const SchedulerMenuButton = ({ isMenuOpen, setIsMenuOpen }) => {
  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (setIsMenuOpen) {
      setIsMenuOpen(!isMenuOpen)
    }
  }
  
  // Always render the button on mobile - never return null
  // This prevents the button from flashing/disappearing during re-renders
  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex md:hidden items-center justify-center p-3 rounded-lg text-gray-700 hover:text-gray-900 hover:bg-gray-100 active:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500 touch-manipulation relative z-[80] flex-shrink-0"
      style={{ 
        minWidth: '48px', 
        minHeight: '48px'
      }}
      aria-expanded={isMenuOpen}
      aria-controls="mobile-menu"
      aria-label="Toggle menu"
    >
      {isMenuOpen ? (
        <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      ) : (
        <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      )}
    </button>
  )
}

export default SchedulerMenuButton
